import { Checkbox, List } from "antd";
import React from "react";

interface IDatasetView {
	item: DocumentDatasetSummary;
	datasets: { [dataset: string]: Array<string> };
	mode: ControlMode;
	onDatasetChange: (item: DocumentDatasetSummary, checkedValue: Array<string>) => void;
}

export default class DatasetView extends React.Component<IDatasetView, {}> {

	private onDatasetChange = (checkedValue: Array<string>) => {
		this.props.onDatasetChange(this.props.item, checkedValue);
	}

	public render() {
		const { item, datasets, mode } = this.props;

		const value: string[] = [];
		const methods = item.methods.map(e => {
			let isSelected = false;
			if (datasets) {
				const dataset = datasets[item.id];
				if (dataset) {
					isSelected = dataset.find(d => d == e.id) != null;
					if (isSelected) {
						value.push(e.id);
					}
				}
			}
			return {
				id: e.id,
				name: e.name,
				checked: isSelected,
			}
		});
		const description = (
			<Checkbox.Group onChange={this.onDatasetChange} value={value} disabled={mode == "display"}>
				{methods.map((m, i) => <Checkbox key={i} checked={m.checked} value={m.id}>{m.name}</Checkbox>)}
			</Checkbox.Group>
		);
		return (
			<List.Item>
				<List.Item.Meta
					title={item.name}
					description={description}
				/>
			</List.Item>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/general/document-templates/form/parts/dataset.view.tsx